// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BGMReadingItem-module__font-s-10___owaS0 {
  font-size: 10px !important;
}

.BGMReadingItem-module__font-s-12___PQhMk {
  font-size: 12px !important;
}

.BGMReadingItem-module__font-s-13___mC7rP {
  font-size: 13px !important;
}

.BGMReadingItem-module__font-s-14___RDvth {
  font-size: 14px !important;
}

.BGMReadingItem-module__font-s-15___MM119 {
  font-size: 15px !important;
}

.BGMReadingItem-module__font-s-16___mNPKB {
  font-size: 16px !important;
}

.BGMReadingItem-module__font-s-18___ghhIi {
  font-size: 18px !important;
}

.BGMReadingItem-module__font-s-20___TXwlr {
  font-size: 20px !important;
}

.BGMReadingItem-module__font-s-22___ikoGD {
  font-size: 22px !important;
}

.BGMReadingItem-module__font-s-28___iDatk {
  font-size: 28px !important;
}

.BGMReadingItem-module__font-w-400___Iwrva {
  font-weight: 400 !important;
}

.BGMReadingItem-module__font-w-500___lKGnk {
  font-weight: 500 !important;
}

.BGMReadingItem-module__font-w-600___j75v0 {
  font-weight: 600 !important;
}

.BGMReadingItem-module__font-w-700___HxRr5 {
  font-weight: 700 !important;
}

.BGMReadingItem-module__p-5___rmIyw {
  padding: 5px !important;
}

.BGMReadingItem-module__p-12___hxFUg {
  padding: 12px !important;
}

.BGMReadingItem-module__p-16___ksY5k {
  padding: 16px !important;
}

.BGMReadingItem-module__p-30___gHAMZ {
  padding: 30px !important;
}

.BGMReadingItem-module__p-b-0___Dyp_D {
  padding-bottom: 0 !important;
}

.BGMReadingItem-module__p-b-5___RcfYb {
  padding-bottom: 5px !important;
}

.BGMReadingItem-module__p-b-10___gJfRU {
  padding-bottom: 10px !important;
}

.BGMReadingItem-module__p-b-12___Gomna {
  padding-bottom: 12px !important;
}

.BGMReadingItem-module__p-b-16___xspA_ {
  padding-bottom: 16px !important;
}

.BGMReadingItem-module__p-b-18___nL0KH {
  padding-bottom: 18px !important;
}

.BGMReadingItem-module__p-b-20___YUWo7 {
  padding-bottom: 20px !important;
}

.BGMReadingItem-module__p-b-25___R5DR7 {
  padding-bottom: 25px !important;
}

.BGMReadingItem-module__p-b-30___e24cV {
  padding-bottom: 30px !important;
}

.BGMReadingItem-module__p-b-50___BM9WS {
  padding-bottom: 50px !important;
}

.BGMReadingItem-module__p-t-0___aPlE5 {
  padding-top: 0 !important;
}

.BGMReadingItem-module__p-t-12___JBr8E {
  padding-top: 12px !important;
}

.BGMReadingItem-module__p-t-16___zx3Fd {
  padding-top: 16px !important;
}

.BGMReadingItem-module__p-t-18___QgLTT {
  padding-top: 18px !important;
}

.BGMReadingItem-module__p-t-20___g2EIo {
  padding-top: 20px !important;
}

.BGMReadingItem-module__p-t-30___xebNw {
  padding-top: 30px !important;
}

.BGMReadingItem-module__p-t-40___X8XpN {
  padding-top: 40px !important;
}

.BGMReadingItem-module__p-t-50___cLioy {
  padding-top: 50px !important;
}

.BGMReadingItem-module__p-l-20___owi_2 {
  padding-left: 20px !important;
}

.BGMReadingItem-module__p-l-30___VMTuF {
  padding-left: 30px !important;
}

.BGMReadingItem-module__p-l-40___BgVz7 {
  padding-left: 40px !important;
}

.BGMReadingItem-module__p-r-16___SRUDb {
  padding-right: 16px !important;
}

.BGMReadingItem-module__p-r-20___s5KaH {
  padding-right: 20px !important;
}

.BGMReadingItem-module__p-r-30___C6qHK {
  padding-right: 30px !important;
}

.BGMReadingItem-module__p-r-50___giG40 {
  padding-right: 50px !important;
}

.BGMReadingItem-module__p-r-60___drGNU {
  padding-right: 60px !important;
}

.BGMReadingItem-module__m-b-1___PGmjq {
  margin-bottom: 1px !important;
}

.BGMReadingItem-module__m-b-2___rPDsd {
  margin-bottom: 2px !important;
}

.BGMReadingItem-module__m-b-6___SzWH5 {
  margin-bottom: 6px !important;
}

.BGMReadingItem-module__m-b-8___wtg7s {
  margin-bottom: 8px !important;
}

.BGMReadingItem-module__m-b-10___Cdi4l {
  margin-bottom: 10px !important;
}

.BGMReadingItem-module__m-b-14___HYTUt {
  margin-bottom: 14px !important;
}

.BGMReadingItem-module__m-b-16___C5ixj {
  margin-bottom: 16px !important;
}

.BGMReadingItem-module__m-b-20___D6y_D {
  margin-bottom: 20px !important;
}

.BGMReadingItem-module__m-b-22___tHssU {
  margin-bottom: 22px !important;
}

.BGMReadingItem-module__m-b-24___wfJ6A {
  margin-bottom: 24px !important;
}

.BGMReadingItem-module__m-b-30___rTaVP {
  margin-bottom: 30px !important;
}

.BGMReadingItem-module__m-b-32___kUK4e {
  margin-bottom: 32px !important;
}

.BGMReadingItem-module__m-b-40___vixP6 {
  margin-bottom: 40px !important;
}

.BGMReadingItem-module__m-t-2___X7srN {
  margin-top: 2px !important;
}

.BGMReadingItem-module__m-t-3___Zco_j {
  margin-top: 3px !important;
}

.BGMReadingItem-module__m-t-4___peBIu {
  margin-top: 4px !important;
}

.BGMReadingItem-module__m-t-5___ug6mn {
  margin-top: 5px !important;
}

.BGMReadingItem-module__m-t-8___WZFrH {
  margin-top: 8px !important;
}

.BGMReadingItem-module__m-t-10___cTwvK {
  margin-top: 10px !important;
}

.BGMReadingItem-module__m-t-15___vS8DS {
  margin-top: 15px !important;
}

.BGMReadingItem-module__m-t-16___eo0be {
  margin-top: 16px !important;
}

.BGMReadingItem-module__m-t-20___SGjl0 {
  margin-top: 20px !important;
}

.BGMReadingItem-module__m-t-22___ooRi3 {
  margin-top: 22px !important;
}

.BGMReadingItem-module__m-t-30___R3gtw {
  margin-top: 30px !important;
}

.BGMReadingItem-module__m-t-32___zgVZ8 {
  margin-top: 32px !important;
}

.BGMReadingItem-module__m-l-auto___vMUw3 {
  margin-left: auto !important;
}

.BGMReadingItem-module__m-l-4___MRHgA {
  margin-left: 4px !important;
}

.BGMReadingItem-module__m-l-5___y_yO2 {
  margin-left: 5px !important;
}

.BGMReadingItem-module__m-l-6___laiNj {
  margin-left: 6px !important;
}

.BGMReadingItem-module__m-l-8___x5dMr {
  margin-left: 8px !important;
}

.BGMReadingItem-module__m-l-10___uGeSI {
  margin-left: 10px !important;
}

.BGMReadingItem-module__m-l-16___vWRom {
  margin-left: 16px !important;
}

.BGMReadingItem-module__m-l-20___cdfh0 {
  margin-left: 20px !important;
}

.BGMReadingItem-module__m-l-24___aI0N6 {
  margin-left: 24px !important;
}

.BGMReadingItem-module__m-l-30___cAhcB {
  margin-left: 30px !important;
}

.BGMReadingItem-module__m-l-35___I2QFK {
  margin-left: 35px !important;
}

.BGMReadingItem-module__m-l-40___BDc_B {
  margin-left: 40px !important;
}

.BGMReadingItem-module__m-r-8___dsp7D {
  margin-right: 8px !important;
}

.BGMReadingItem-module__m-r-10___fUKA0 {
  margin-right: 10px !important;
}

.BGMReadingItem-module__m-r-16___haTWq {
  margin-right: 16px !important;
}

.BGMReadingItem-module__m-r-20___FlxlT {
  margin-right: 20px !important;
}

.BGMReadingItem-module__m-r-24___f_zmW {
  margin-right: 24px !important;
}

.BGMReadingItem-module__m-r-30___dVcey {
  margin-right: 30px !important;
}

.BGMReadingItem-module__m-r-40___j4Cd6 {
  margin-right: 40px !important;
}

.BGMReadingItem-module__border-r-3___OF0mz {
  border-radius: 3px !important;
}

.BGMReadingItem-module__border-r-4___dYBUQ {
  border-radius: 4px !important;
}

.BGMReadingItem-module__border-r-6___oD9k4 {
  border-radius: 6px !important;
}

.BGMReadingItem-module__border-r-10___wqbm3 {
  border-radius: 10px !important;
}

.BGMReadingItem-module__border-r-12___spiCi {
  border-radius: 12px !important;
}

.BGMReadingItem-module__border-r-16___gsdnv {
  border-radius: 16px !important;
}

.BGMReadingItem-module__border-r-50___gEsnF {
  border-radius: 50% !important;
}

.BGMReadingItem-module__primary-border___rMdp5 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMReadingItem-module__primary-border-b___c_mhL {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMReadingItem-module__primary-border-t___bllon {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMReadingItem-module__primary-border-l___nSEQQ {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMReadingItem-module__primary-border-r___Ot7HW {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMReadingItem-module__secondary-border___zXd7b {
  border: 1px solid #637768;
}

.BGMReadingItem-module__secondary-border-b___mdYx1 {
  border-bottom: 1px solid #637768;
}

.BGMReadingItem-module__secondary-border-t___OFpi4 {
  border-top: 1px solid #637768;
}

.BGMReadingItem-module__secondary-border-l___wtWLe {
  border-left: 1px solid #637768;
}

.BGMReadingItem-module__secondary-border-r___F5moy {
  border-right: 1px solid #637768;
}

.BGMReadingItem-module__gap-0___vcpMO {
  gap: 0 !important;
}

.BGMReadingItem-module__gap-2___tanwB {
  gap: 2px !important;
}

.BGMReadingItem-module__gap-4___BRJ0A {
  gap: 4px !important;
}

.BGMReadingItem-module__gap-5___yHCEs {
  gap: 5px !important;
}

.BGMReadingItem-module__gap-6___kN0gU {
  gap: 6px !important;
}

.BGMReadingItem-module__gap-8___gVidt {
  gap: 8px !important;
}

.BGMReadingItem-module__gap-10___i1Wr4 {
  gap: 10px !important;
}

.BGMReadingItem-module__gap-12___PLV_a {
  gap: 12px !important;
}

.BGMReadingItem-module__gap-14___iiSEs {
  gap: 14px !important;
}

.BGMReadingItem-module__gap-16___Goadl {
  gap: 16px !important;
}

.BGMReadingItem-module__gap-18___A5mmW {
  gap: 18px !important;
}

.BGMReadingItem-module__gap-20___rdIKP {
  gap: 20px !important;
}

.BGMReadingItem-module__gap-24___poNxl {
  gap: 24px !important;
}

.BGMReadingItem-module__gap-26___JbLSG {
  gap: 26px !important;
}

.BGMReadingItem-module__gap-30___EhBBI {
  gap: 30px !important;
}

.BGMReadingItem-module__gap-32___Ru_yK {
  gap: 32px !important;
}

.BGMReadingItem-module__gap-40___osuDZ {
  gap: 40px !important;
}

.BGMReadingItem-module__gap-50___rOFKl {
  gap: 50px !important;
}

.BGMReadingItem-module__flex-1___D23My {
  flex: 1;
}

.BGMReadingItem-module__flex-none___xSr1b {
  flex: none !important;
}

.BGMReadingItem-module__flex-column___u5mHv {
  display: flex;
  flex-direction: column !important;
}

.BGMReadingItem-module__flex-row___hTlKw {
  display: flex;
  flex-direction: row !important;
}

.BGMReadingItem-module__vertically-centered___ci_GZ {
  display: flex;
  align-items: center !important;
}

.BGMReadingItem-module__horizontally-centered___MSLUF {
  display: flex;
  justify-content: center !important;
}

.BGMReadingItem-module__horizontally-end___Wfd51 {
  display: flex;
  justify-content: end !important;
}

.BGMReadingItem-module__vertically-start___dTS7y {
  display: flex;
  align-items: start !important;
}

.BGMReadingItem-module__space-between___S9LL_ {
  display: flex;
  justify-content: space-between !important;
}

.BGMReadingItem-module__flex-wrap___AyGEE {
  flex-wrap: wrap !important;
}

.BGMReadingItem-module__height-100____S6Td {
  height: 100%;
}

.BGMReadingItem-module__width-50___ukm4M {
  width: 50% !important;
}

.BGMReadingItem-module__width-100___mFxYM {
  width: 100%;
}

.BGMReadingItem-module__cursor-pointer___IbXw7 {
  cursor: pointer;
}

.BGMReadingItem-module__cursor-not-allowed___A0VLg {
  cursor: not-allowed !important;
}

.BGMReadingItem-module__absolute-centered___AymzY {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.BGMReadingItem-module__absolute___dOleL {
  position: absolute;
}

.BGMReadingItem-module__relative___HXvu4 {
  position: relative;
}

.BGMReadingItem-module__fixed___BeYdS {
  position: fixed;
}

.BGMReadingItem-module__visible___Ln1KB {
  opacity: 1;
}

.BGMReadingItem-module__invisible___RvNJu {
  opacity: 0;
}

.BGMReadingItem-module__col-90___WfUYg {
  width: 90% !important;
}

.BGMReadingItem-module__col-auto___L0GQt {
  width: auto !important;
}

.BGMReadingItem-module__medical-tabs___jmr8c {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.BGMReadingItem-module__medical-table-new___emCao {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.BGMReadingItem-module__medical-table-new___emCao:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BGMReadingItem-module__medical-table-new___emCao::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BGMReadingItem-module__medical-table-new___emCao::-webkit-scrollbar-track {
  display: none;
}
.BGMReadingItem-module__medical-table-new___emCao.BGMReadingItem-module__no-pagination____WT2N {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.BGMReadingItem-module__medical-table-new___emCao.BGMReadingItem-module__no-pagination____WT2N:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BGMReadingItem-module__medical-table-new___emCao.BGMReadingItem-module__no-pagination____WT2N::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BGMReadingItem-module__medical-table-new___emCao.BGMReadingItem-module__no-pagination____WT2N::-webkit-scrollbar-track {
  display: none;
}

.BGMReadingItem-module__medical-table-empty___jHbgm {
  padding: 14px 40px !important;
}

.BGMReadingItem-module__icon-btn___YqFZr {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.BGMReadingItem-module__search-icon___MUyn_ {
  width: 24px;
  height: 24px;
  align-self: center;
}

.BGMReadingItem-module__disable-select___mHzbC {
  user-select: none;
}

.BGMReadingItem-module__break-word___hNCmw {
  word-break: break-word;
}

.BGMReadingItem-module__popup-clear-btn___jvvBU {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.BGMReadingItem-module__scroll-m-b-20___lKxEe {
  scroll-margin-bottom: 20px;
}

.BGMReadingItem-module__item___sJDJN {
  color: #375844;
  cursor: default;
  height: 31px;
  width: 40px;
}

.BGMReadingItem-module__tooltip___Kn1nu {
  color: #375844;
  width: max-content;
  z-index: 1000;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Biometrics/items/BGMReadingItem/BGMReadingItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AA8pBF;;AA3pBA;EACE,cAAA;EACA,kBAAA;EACA,aAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.item {\n  color: get-color(greenNew, dark);\n  cursor: default;\n  height: 31px;\n  width: 40px;\n}\n\n.tooltip {\n  color: get-color(greenNew, dark);\n  width: max-content;\n  z-index: 1000;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `BGMReadingItem-module__font-s-10___owaS0`,
	"fontS12": `BGMReadingItem-module__font-s-12___PQhMk`,
	"fontS13": `BGMReadingItem-module__font-s-13___mC7rP`,
	"fontS14": `BGMReadingItem-module__font-s-14___RDvth`,
	"fontS15": `BGMReadingItem-module__font-s-15___MM119`,
	"fontS16": `BGMReadingItem-module__font-s-16___mNPKB`,
	"fontS18": `BGMReadingItem-module__font-s-18___ghhIi`,
	"fontS20": `BGMReadingItem-module__font-s-20___TXwlr`,
	"fontS22": `BGMReadingItem-module__font-s-22___ikoGD`,
	"fontS28": `BGMReadingItem-module__font-s-28___iDatk`,
	"fontW400": `BGMReadingItem-module__font-w-400___Iwrva`,
	"fontW500": `BGMReadingItem-module__font-w-500___lKGnk`,
	"fontW600": `BGMReadingItem-module__font-w-600___j75v0`,
	"fontW700": `BGMReadingItem-module__font-w-700___HxRr5`,
	"p5": `BGMReadingItem-module__p-5___rmIyw`,
	"p12": `BGMReadingItem-module__p-12___hxFUg`,
	"p16": `BGMReadingItem-module__p-16___ksY5k`,
	"p30": `BGMReadingItem-module__p-30___gHAMZ`,
	"pB0": `BGMReadingItem-module__p-b-0___Dyp_D`,
	"pB5": `BGMReadingItem-module__p-b-5___RcfYb`,
	"pB10": `BGMReadingItem-module__p-b-10___gJfRU`,
	"pB12": `BGMReadingItem-module__p-b-12___Gomna`,
	"pB16": `BGMReadingItem-module__p-b-16___xspA_`,
	"pB18": `BGMReadingItem-module__p-b-18___nL0KH`,
	"pB20": `BGMReadingItem-module__p-b-20___YUWo7`,
	"pB25": `BGMReadingItem-module__p-b-25___R5DR7`,
	"pB30": `BGMReadingItem-module__p-b-30___e24cV`,
	"pB50": `BGMReadingItem-module__p-b-50___BM9WS`,
	"pT0": `BGMReadingItem-module__p-t-0___aPlE5`,
	"pT12": `BGMReadingItem-module__p-t-12___JBr8E`,
	"pT16": `BGMReadingItem-module__p-t-16___zx3Fd`,
	"pT18": `BGMReadingItem-module__p-t-18___QgLTT`,
	"pT20": `BGMReadingItem-module__p-t-20___g2EIo`,
	"pT30": `BGMReadingItem-module__p-t-30___xebNw`,
	"pT40": `BGMReadingItem-module__p-t-40___X8XpN`,
	"pT50": `BGMReadingItem-module__p-t-50___cLioy`,
	"pL20": `BGMReadingItem-module__p-l-20___owi_2`,
	"pL30": `BGMReadingItem-module__p-l-30___VMTuF`,
	"pL40": `BGMReadingItem-module__p-l-40___BgVz7`,
	"pR16": `BGMReadingItem-module__p-r-16___SRUDb`,
	"pR20": `BGMReadingItem-module__p-r-20___s5KaH`,
	"pR30": `BGMReadingItem-module__p-r-30___C6qHK`,
	"pR50": `BGMReadingItem-module__p-r-50___giG40`,
	"pR60": `BGMReadingItem-module__p-r-60___drGNU`,
	"mB1": `BGMReadingItem-module__m-b-1___PGmjq`,
	"mB2": `BGMReadingItem-module__m-b-2___rPDsd`,
	"mB6": `BGMReadingItem-module__m-b-6___SzWH5`,
	"mB8": `BGMReadingItem-module__m-b-8___wtg7s`,
	"mB10": `BGMReadingItem-module__m-b-10___Cdi4l`,
	"mB14": `BGMReadingItem-module__m-b-14___HYTUt`,
	"mB16": `BGMReadingItem-module__m-b-16___C5ixj`,
	"mB20": `BGMReadingItem-module__m-b-20___D6y_D`,
	"mB22": `BGMReadingItem-module__m-b-22___tHssU`,
	"mB24": `BGMReadingItem-module__m-b-24___wfJ6A`,
	"mB30": `BGMReadingItem-module__m-b-30___rTaVP`,
	"mB32": `BGMReadingItem-module__m-b-32___kUK4e`,
	"mB40": `BGMReadingItem-module__m-b-40___vixP6`,
	"mT2": `BGMReadingItem-module__m-t-2___X7srN`,
	"mT3": `BGMReadingItem-module__m-t-3___Zco_j`,
	"mT4": `BGMReadingItem-module__m-t-4___peBIu`,
	"mT5": `BGMReadingItem-module__m-t-5___ug6mn`,
	"mT8": `BGMReadingItem-module__m-t-8___WZFrH`,
	"mT10": `BGMReadingItem-module__m-t-10___cTwvK`,
	"mT15": `BGMReadingItem-module__m-t-15___vS8DS`,
	"mT16": `BGMReadingItem-module__m-t-16___eo0be`,
	"mT20": `BGMReadingItem-module__m-t-20___SGjl0`,
	"mT22": `BGMReadingItem-module__m-t-22___ooRi3`,
	"mT30": `BGMReadingItem-module__m-t-30___R3gtw`,
	"mT32": `BGMReadingItem-module__m-t-32___zgVZ8`,
	"mLAuto": `BGMReadingItem-module__m-l-auto___vMUw3`,
	"mL4": `BGMReadingItem-module__m-l-4___MRHgA`,
	"mL5": `BGMReadingItem-module__m-l-5___y_yO2`,
	"mL6": `BGMReadingItem-module__m-l-6___laiNj`,
	"mL8": `BGMReadingItem-module__m-l-8___x5dMr`,
	"mL10": `BGMReadingItem-module__m-l-10___uGeSI`,
	"mL16": `BGMReadingItem-module__m-l-16___vWRom`,
	"mL20": `BGMReadingItem-module__m-l-20___cdfh0`,
	"mL24": `BGMReadingItem-module__m-l-24___aI0N6`,
	"mL30": `BGMReadingItem-module__m-l-30___cAhcB`,
	"mL35": `BGMReadingItem-module__m-l-35___I2QFK`,
	"mL40": `BGMReadingItem-module__m-l-40___BDc_B`,
	"mR8": `BGMReadingItem-module__m-r-8___dsp7D`,
	"mR10": `BGMReadingItem-module__m-r-10___fUKA0`,
	"mR16": `BGMReadingItem-module__m-r-16___haTWq`,
	"mR20": `BGMReadingItem-module__m-r-20___FlxlT`,
	"mR24": `BGMReadingItem-module__m-r-24___f_zmW`,
	"mR30": `BGMReadingItem-module__m-r-30___dVcey`,
	"mR40": `BGMReadingItem-module__m-r-40___j4Cd6`,
	"borderR3": `BGMReadingItem-module__border-r-3___OF0mz`,
	"borderR4": `BGMReadingItem-module__border-r-4___dYBUQ`,
	"borderR6": `BGMReadingItem-module__border-r-6___oD9k4`,
	"borderR10": `BGMReadingItem-module__border-r-10___wqbm3`,
	"borderR12": `BGMReadingItem-module__border-r-12___spiCi`,
	"borderR16": `BGMReadingItem-module__border-r-16___gsdnv`,
	"borderR50": `BGMReadingItem-module__border-r-50___gEsnF`,
	"primaryBorder": `BGMReadingItem-module__primary-border___rMdp5`,
	"primaryBorderB": `BGMReadingItem-module__primary-border-b___c_mhL`,
	"primaryBorderT": `BGMReadingItem-module__primary-border-t___bllon`,
	"primaryBorderL": `BGMReadingItem-module__primary-border-l___nSEQQ`,
	"primaryBorderR": `BGMReadingItem-module__primary-border-r___Ot7HW`,
	"secondaryBorder": `BGMReadingItem-module__secondary-border___zXd7b`,
	"secondaryBorderB": `BGMReadingItem-module__secondary-border-b___mdYx1`,
	"secondaryBorderT": `BGMReadingItem-module__secondary-border-t___OFpi4`,
	"secondaryBorderL": `BGMReadingItem-module__secondary-border-l___wtWLe`,
	"secondaryBorderR": `BGMReadingItem-module__secondary-border-r___F5moy`,
	"gap0": `BGMReadingItem-module__gap-0___vcpMO`,
	"gap2": `BGMReadingItem-module__gap-2___tanwB`,
	"gap4": `BGMReadingItem-module__gap-4___BRJ0A`,
	"gap5": `BGMReadingItem-module__gap-5___yHCEs`,
	"gap6": `BGMReadingItem-module__gap-6___kN0gU`,
	"gap8": `BGMReadingItem-module__gap-8___gVidt`,
	"gap10": `BGMReadingItem-module__gap-10___i1Wr4`,
	"gap12": `BGMReadingItem-module__gap-12___PLV_a`,
	"gap14": `BGMReadingItem-module__gap-14___iiSEs`,
	"gap16": `BGMReadingItem-module__gap-16___Goadl`,
	"gap18": `BGMReadingItem-module__gap-18___A5mmW`,
	"gap20": `BGMReadingItem-module__gap-20___rdIKP`,
	"gap24": `BGMReadingItem-module__gap-24___poNxl`,
	"gap26": `BGMReadingItem-module__gap-26___JbLSG`,
	"gap30": `BGMReadingItem-module__gap-30___EhBBI`,
	"gap32": `BGMReadingItem-module__gap-32___Ru_yK`,
	"gap40": `BGMReadingItem-module__gap-40___osuDZ`,
	"gap50": `BGMReadingItem-module__gap-50___rOFKl`,
	"flex1": `BGMReadingItem-module__flex-1___D23My`,
	"flexNone": `BGMReadingItem-module__flex-none___xSr1b`,
	"flexColumn": `BGMReadingItem-module__flex-column___u5mHv`,
	"flexRow": `BGMReadingItem-module__flex-row___hTlKw`,
	"verticallyCentered": `BGMReadingItem-module__vertically-centered___ci_GZ`,
	"horizontallyCentered": `BGMReadingItem-module__horizontally-centered___MSLUF`,
	"horizontallyEnd": `BGMReadingItem-module__horizontally-end___Wfd51`,
	"verticallyStart": `BGMReadingItem-module__vertically-start___dTS7y`,
	"spaceBetween": `BGMReadingItem-module__space-between___S9LL_`,
	"flexWrap": `BGMReadingItem-module__flex-wrap___AyGEE`,
	"height100": `BGMReadingItem-module__height-100____S6Td`,
	"width50": `BGMReadingItem-module__width-50___ukm4M`,
	"width100": `BGMReadingItem-module__width-100___mFxYM`,
	"cursorPointer": `BGMReadingItem-module__cursor-pointer___IbXw7`,
	"cursorNotAllowed": `BGMReadingItem-module__cursor-not-allowed___A0VLg`,
	"absoluteCentered": `BGMReadingItem-module__absolute-centered___AymzY`,
	"absolute": `BGMReadingItem-module__absolute___dOleL`,
	"relative": `BGMReadingItem-module__relative___HXvu4`,
	"fixed": `BGMReadingItem-module__fixed___BeYdS`,
	"visible": `BGMReadingItem-module__visible___Ln1KB`,
	"invisible": `BGMReadingItem-module__invisible___RvNJu`,
	"col90": `BGMReadingItem-module__col-90___WfUYg`,
	"colAuto": `BGMReadingItem-module__col-auto___L0GQt`,
	"medicalTabs": `BGMReadingItem-module__medical-tabs___jmr8c`,
	"medicalTableNew": `BGMReadingItem-module__medical-table-new___emCao`,
	"noPagination": `BGMReadingItem-module__no-pagination____WT2N`,
	"medicalTableEmpty": `BGMReadingItem-module__medical-table-empty___jHbgm`,
	"iconBtn": `BGMReadingItem-module__icon-btn___YqFZr`,
	"searchIcon": `BGMReadingItem-module__search-icon___MUyn_`,
	"disableSelect": `BGMReadingItem-module__disable-select___mHzbC`,
	"breakWord": `BGMReadingItem-module__break-word___hNCmw`,
	"popupClearBtn": `BGMReadingItem-module__popup-clear-btn___jvvBU`,
	"scrollMB20": `BGMReadingItem-module__scroll-m-b-20___lKxEe`,
	"item": `BGMReadingItem-module__item___sJDJN`,
	"tooltip": `BGMReadingItem-module__tooltip___Kn1nu`
};
module.exports = ___CSS_LOADER_EXPORT___;
